import { instance as axios, setJwtToken } from "../../config/axiosInstance";

// ------------------------ Get Report List ------------------
export const getReportListApi = async (data) => {
  const endPoint = `admin/report/list?${new URLSearchParams({
    ...data,
  }).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};

// ------------------------ Get Report Detail ------------------
export const getReportDetailApi = async (data) => {
  const endPoint = `admin/report?${new URLSearchParams({
    ...data,
  }).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};

// ------------------------ Report status change ------------------
export const updateReportApi = async (data) => {
  const endPoint = `admin/report`;
  return await axios.put(endPoint, data, setJwtToken());
};

// ------------------------ Delete Report ------------------
export const deleteReportApi = async (data) => {
  const endPoint = `admin/report?${new URLSearchParams({
    ...data,
  }).toString()}`;
  return await axios.delete(endPoint, setJwtToken());
};
